import { render, staticRenderFns } from "./congbodialog.vue?vue&type=template&id=2926b06e&scoped=true&"
import script from "./congbodialog.vue?vue&type=script&lang=js&"
export * from "./congbodialog.vue?vue&type=script&lang=js&"
import style0 from "./congbodialog.vue?vue&type=style&index=0&id=2926b06e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2926b06e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
